"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberValidator = void 0;
const Validator_1 = require("../validator/Validator");
const ERRORS = {
    IS_DECIMAL: 'IS_DECIMAL',
    IS_EQUAL: 'IS_EQUAL',
    IS_INTEGER: 'IS_INTEGER',
    IS_NEGATIVE: 'IS_NEGATIVE',
    IS_NUMBER: 'IS_NUMBER',
    IS_POSITIVE: 'IS_POSITIVE',
    IS_ZERO: 'IS_ZERO',
    MAX: 'MAX',
    MIN: 'MIN',
};
class NumberValidator extends Validator_1.Validator {
    static isDecimal(value) {
        return _a.isNumber(value) && !Number.isInteger(value);
    }
    static isEqualTo(value, equalTo) {
        return value === equalTo;
    }
    static isEqualToZero(value) {
        return _a.isNumber(value) && value === 0;
    }
    static isInteger(value) {
        return _a.isNumber(value) && Number.isInteger(value);
    }
    static isNegative(value) {
        return _a.isNumber(value) && value < 0;
    }
    static isNumber(value) {
        return typeof value === 'number';
    }
    static isPositive(value) {
        return _a.isNumber(value) && value >= 0;
    }
    static maximum(value, max) {
        return _a.isNumber(value) && value <= max;
    }
    static minimum(value, min) {
        return _a.isNumber(value) && value >= min;
    }
}
exports.NumberValidator = NumberValidator;
_a = NumberValidator;
NumberValidator.IS_DECIMAL = () => _a.validatorFactory(_a.isDecimal, ERRORS.IS_DECIMAL);
NumberValidator.IS_EQUAL = (equalTo) => _a.validatorFactory(value => _a.isEqualTo(value, equalTo), ERRORS.IS_EQUAL);
NumberValidator.IS_INTEGER = () => _a.validatorFactory(_a.isInteger, ERRORS.IS_INTEGER);
NumberValidator.IS_NEGATIVE = () => _a.validatorFactory(_a.isNegative, ERRORS.IS_NEGATIVE);
NumberValidator.IS_NUMBER = () => _a.validatorFactory(_a.isNumber, ERRORS.IS_NUMBER);
NumberValidator.IS_POSITIVE = () => _a.validatorFactory(_a.isPositive, ERRORS.IS_POSITIVE);
NumberValidator.IS_ZERO = () => _a.validatorFactory(_a.isEqualToZero, ERRORS.IS_ZERO);
NumberValidator.MAX = (max) => _a.validatorFactory(value => _a.maximum(value, max), ERRORS.MAX);
NumberValidator.MIN = (min) => _a.validatorFactory(value => _a.minimum(value, min), ERRORS.MIN);
//# sourceMappingURL=NumberValidator.js.map